import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// check is a token exists and is not expired.
// If so, redirects the user to the app's main page.
// Otherwise, forces the user to log in.
const hasValidToken = () => {
    const { token, exp } = { ...localStorage };
    if (token && exp) {
        if (exp < new Date().getTime() / 1000) {
            localStorage.clear();
            return false;
        }
        return true;
    }
    return false;
};

function RedirectIfLoggedInRoute() {
    return hasValidToken() ? <Navigate to="/cases" /> : <Outlet />;
}

export default RedirectIfLoggedInRoute;
